import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Control Panel", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Make up ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Generate")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Make up Params", -1)
const _hoisted_5 = { style: {"height":"100%","display":"flex","align-items":"center"} }
const _hoisted_6 = { style: {"margin-left":"10px","font-weight":"bold"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Face 1"),
  /*#__PURE__*/_createElementVNode("h6", null, "Face 2")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Detail Setting ")
const _hoisted_9 = { style: {"height":"150px","display":"flex","overflow":"auto"} }
const _hoisted_10 = {
  key: 2,
  style: {"display":"flex","justify-content":"space-between","flex-wrap":"wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"height":"100%"} }, {
    title: _withCtx(() => [
      _createVNode(_component_a_row, { type: "flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { flex: "1 1 120px" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: "0 1" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.isGenFace,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isGenFace) = $event)),
                "button-style": "solid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_button, {
                    value: false,
                    disabled: _ctx.fileLength > 2
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_a_radio_button, { value: true }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (!_ctx.isGenFace)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.makeupParamOptions, ({ label }, index) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: 'makeup-' + index,
                style: {"display":"flex"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(label), 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.makeUpParams[index]) + "% ", 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 14 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_slider, {
                        value: _ctx.makeUpParams[index],
                        "onUpdate:value": ($event: any) => ((_ctx.makeUpParams[index]) = $event),
                        style: {"width":"100%"},
                        "tip-formatter": _ctx.formatter
                      }, null, 8, ["value", "onUpdate:value", "tip-formatter"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ], 64))
        : (_ctx.fileLength < 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h4", null, "Face Ratio: " + _toDisplayString(_ctx.duoFacesRatio) + "%", 1),
              _hoisted_7,
              _createVNode(_component_a_slider, {
                value: _ctx.duoFacesRatio,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.duoFacesRatio) = $event)),
                "tip-formatter": _ctx.formatter,
                onChange: _ctx.onChangeDuoFacesRatio
              }, null, 8, ["value", "tip-formatter", "onChange"]),
              _createVNode(_component_a_collapse, { ghost: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, null, {
                    header: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duoParams, (param, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `param-${index}`,
                            style: {"display":"flex","height":"150px","align-items":"center","flex-direction":"column"}
                          }, [
                            _createVNode(_component_a_slider, {
                              value: _ctx.duoParams[index],
                              "onUpdate:value": ($event: any) => ((_ctx.duoParams[index]) = $event),
                              style: {"display":"inline-block"},
                              vertical: ""
                            }, null, 8, ["value", "onUpdate:value"]),
                            _createTextVNode(" " + _toDisplayString(index + 1), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(_ctx.fileLength), (face, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {"display":"flex","flex-direction":"column","align-items":"center","height":"200px"}
                }, [
                  _createVNode(_component_a_slider, {
                    value: _ctx.multiFacesRatio[index],
                    "onUpdate:value": ($event: any) => ((_ctx.multiFacesRatio[index]) = $event),
                    vertical: "",
                    "tip-formatter": _ctx.formatter,
                    min: 1
                  }, null, 8, ["value", "onUpdate:value", "tip-formatter"]),
                  _createTextVNode(" " + _toDisplayString(index + 1), 1)
                ]))
              }), 128))
            ]))
    ]),
    _: 1
  }))
}